import { FC } from 'react'
import TitlePage from '../components/common/title/TitlePage'
import ShippingCarrierList from '../components/shippingCarriers/ShippingCarrierList'
import Page2Line from '../layouts/dashboard/Page2Line'
import Meta from '../layouts/Meta'

const ShippingCarriersPage: FC = () => (
  <>
    <Meta title='Shipping Carriers' />
    <Page2Line noPadding header={<TitlePage>Shipping Carriers</TitlePage>}>
      <ShippingCarrierList />
    </Page2Line>
  </>
)

export default ShippingCarriersPage
